<!-- 调试示例：http://localhost:8080/#/aiShare?jsonUrl=https%3A%2F%2Fql-hospital-test.oss-cn-beijing.aliyuncs.com%2Fpub%2Ffile%2Feeg%2FADT_R20240814153930.json -->

<template>
	<div :class="isMobile ? 'mobileContent' : 'pcContent'">
		<div v-if="isMobile" style="display: flex; flex-direction: column; height: 100%; background: rgba(236, 240, 243, 1); align-items: center;" v-loading="isLoading" element-loading-text="数据加载中，请稍候...">
			<img style="position: absolute; width: 100%; height: 370px; left: 0px; top: 0px; z-index: 0;" src="../../assets/icon_home_ai_icon_15.png" alt="" draggable="false" />
			<div style="position: relative; display: flex; flex-direction: column; overflow: hidden; flex: 1; width: 100%;">
				<div id="contentScrollId" :class="['tca', 'contentScrollClass']" style="display: block; flex-direction: column; align-self: flex-start; overflow: scroll; width: 100%; padding-bottom: 100px; flex: 1;" draggable="false">
					

					<div v-for="(item, index) in msgArr" style="display: flex; flex-direction: column; margin-left: 15px; margin-right: 15px;">
						<div v-if="item.type == 'analysis' && index <= showLastIndex" style="display: flex; justify-content: flex-end;">
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px; padding: 20px; background: rgba(74, 124, 232, 0.2); border-radius: 12px 2px 12px 12px; margin-top: 15px; align-self: flex-end; min-width: 295px;">{{ item.text ? item.text : (item.title ? item.title : '') }}</div>
						</div>
						<div v-else-if="item.type == 'aiContent' && index <= showLastIndex" style="display: flex;">
							<AiShareCard1 :data="item" :dataIndex="index"  />
						</div>
					</div>


				</div>
				<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px; padding-top: 5px;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 0.6); line-height: 20px;">内容由 AI 大模型生成，请仔细甄别</div>
				</div>
			</div>
		</div>
		<div v-if="!isMobile" style="display: flex; flex-direction: column; height: 100%; background: rgba(236, 240, 243, 1); align-items: center;" v-loading="isLoading" element-loading-text="数据加载中，请稍候...">
			<img style="position: absolute; width: 100%; height: 370px; left: 0px; top: 50px; z-index: 0;" src="../../assets/icon_home_ai_icon_13.png" alt="" draggable="false" />
			<div style="display: flex; justify-content: center; align-items: center; background: rgba(236, 240, 243, 1); z-index: 1; width: 100%;">
				<img style="width: 46px; height: 40px; margin-top: 5px; margin-bottom: 5px;" src="../../assets/icon_home_ai_icon_12.png" alt="" draggable="false" />
			</div>
			<div style="position: relative; display: flex; flex-direction: column; overflow: hidden; width: 840px;">
				<div id="contentScrollId" :class="['tca', 'contentScrollClass']" style="display: block; flex-direction: column; align-self: flex-start; overflow: scroll; width: 100%; padding-bottom: 100px;" draggable="false">
					

					<div v-for="(item, index) in msgArr" style="display: flex; flex-direction: column;">
						<div v-if="item.type == 'analysis' && index <= showLastIndex" style="display: flex; justify-content: flex-end;">
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px; padding: 20px; background: rgba(74, 124, 232, 0.2); border-radius: 12px 2px 12px 12px; margin-top: 15px; align-self: flex-end; min-width: 391px;">{{ item.text ? item.text : (item.title ? item.title : '') }}</div>
						</div>
						<div v-else-if="item.type == 'aiContent' && index <= showLastIndex" style="display: flex;">
							<AiShareCard1 :data="item" :dataIndex="index"  />
						</div>
					</div>


				</div>
				<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 0.6); line-height: 20px;">内容由 AI 大模型生成，请仔细甄别</div>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>

import axios from 'axios';
import AiShareCard1 from "./aiShareCard1.vue"
import wx from "weixin-js-sdk";
import API_CONFIG from "../../../vue.config.js"

export default {
	components: { AiShareCard1 },
	props: {
	},
	computed: {
	},
	watch: {
		
	},
	data() {
		return {
			params: null,
			isLoading: false,
			msgArr: null,
			isMobile: true,
			showLastIndex: null,
			shareTitle: '',
			shareSubTitle: ''
		};
	},
	created() {

	},
	mounted() {
		document.title = '清雷AI助手'
		
		
		this.$nextTick(() => {
			this.isMobile = this.judgeIsMobile();

			// 1.获取 query 参数
			let params = this.$route.query;
			this.params = JSON.parse(JSON.stringify(params));

			this.requestAiContent();

			this.wxShareConfig();
		});
	},
	methods: {
		requestAiContent() {
			if (this.params && this.params.jsonUrl) {
				this.isLoading = true;
				axios({
					method: 'get',
					url: this.params.jsonUrl,
					headers: {
						'Content-Type': 'application/json',
						'Cache-Control': 'no-cache',
						'Pragma': 'no-cache'
					},
				})
				.then((res) => {
					this.showLastIndex = res.showLastIndex;
					this.msgArr = res.msgArr;
					this.shareTitle = res.shareTitle;
					this.shareSubTitle = res.shareSubTitle;

					this.isLoading = false;
				})
				.catch(() => {
					this.isLoading = false;
				});
			}
		},
		judgeIsMobile() {
			// 判断是否为移动设备
			return (
				typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
				navigator.userAgent.indexOf('IEMobile') !== -1 || // 判断是否为Windows Phone
				navigator.userAgent.indexOf('iPhone') !== -1 || // 判断是否为iPhone
				navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile') !== -1 || // 判断是否为Android手机
				navigator.userAgent.indexOf('BlackBerry') !== -1 || // 判断是否为BlackBerry
				navigator.userAgent.indexOf('Opera Mini') !== -1 // 判断是否为Opera Mini浏览器
			);
		},
		wxShareConfig() {
			var that = this;
			var url = window.location.href.split("#")[0];
			var url2 = window.location.href;
			var targetUrl = API_CONFIG.devServer.proxy['/api'].target + '/'
			// var targetUrl = 'http://dev.qingleitech.com/'
			// var targetUrl = 'http://192.168.1.177:8083/api/'
			this.$get(
				targetUrl + "api/hmp/wechat/getSignature",
				{ url: url },
				(res) => {
				var result = res.data;
				console.log(result);
				//返回需要的参数appId,timestamp,noncestr,signature等
				//注入config权限配置
				console.log(result.jsapi_ticket)
				console.log(result.timestamp)
				wx.config({
					debug: false,
					appId: result.appId,
					timestamp: result.timestamp,    // 必填，生成签名的时间戳
					nonceStr: result.nonceStr,      // 必填，生成签名的随机串
					signature: result.signature,    // 必填，签名
					jsApiList: [
					//这里是需要用到的接口名称
					"checkJsApi", //判断当前客户端版本是否支持指定JS接口
					"updateAppMessageShareData",    //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
					],
				});
				wx.error(function(error) {
					console.log(error)
				})
				wx.ready(() =>{
					//自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
					wx.updateAppMessageShareData({
					title: this.shareTitle, //分享标题
					desc: this.shareSubTitle, //分享描述

					link: url2, //分享链接

					imgUrl: "http://dev.qingleitech.com/ai_share_logo.png", //分享图标

					success: function () {
						console.log('设置成功updateAppMessageShareData')
					},
					cancel: function () {
						console.log('设置失败updateAppMessageShareData')
					},
					fail: function (err){
						console.log('fail')
						console.log(err)
					}
					});
				});
				
				},
				(err) => {
				console.log("fail" + JSON.stringify(err));
				console.log("fail" + err);
				}
			);
			
		},
	},
};
</script>
<style lang="scss" scoped>
.pcContent {
	display: flex; 
	flex-direction: column;
	height: 100%
}

.mobileContent {
	display: flex; 
	flex-direction: column;
	height: 100%
}

</style>
<style>
.contentScrollClass::-webkit-scrollbar {
	display: none
}
</style>